import React from "react";
import {
  Box,
  Typography,
  Button,
  ToggleButton,
  ToggleButtonGroup,
  Chip,
  Tooltip,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import MenuIcon from "@mui/icons-material/Menu";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

const AdminBookingHeader = ({
  showLegacy,
  onToggleLegacy,
  onRefresh,
  filteredCount,
  totalCount,
  lastRefreshedAt,
  tick,
  onOpenNav, // NEW
}) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box
      sx={{
        px: { xs: 2, sm: 3 },
        pt: 2,
        pb: 1,
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        flexWrap: "wrap",
        justifyContent: "space-between",
      }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
        <Typography variant="h6" fontWeight={700} sx={{ lineHeight: 1 }}>
          {showLegacy ? "Archived Bookings" : "New Bookings"}
        </Typography>
        <Chip
          size="small"
          variant="outlined"
          label={`${filteredCount}/${totalCount}`}
        />
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <ToggleButtonGroup
          size="small"
          exclusive
          value={showLegacy ? "archived" : "new"}
          onChange={(_, val) => val && onToggleLegacy(val === "archived")}>
          <ToggleButton value="new">New</ToggleButton>
          <ToggleButton value="archived">Archived</ToggleButton>
        </ToggleButtonGroup>

        <Tooltip title="Refresh (R)">
          <Button
            size="small"
            onClick={onRefresh}
            startIcon={<RefreshIcon fontSize="small" />}>
            Refresh
          </Button>
        </Tooltip>

        {lastRefreshedAt && (
          <Typography key={tick} variant="caption" color="text.secondary">
            Updated {dayjs(lastRefreshedAt).fromNow()}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default AdminBookingHeader;
